import { defineStore } from "pinia";
// import url from "../axios/url";
// import axios from "axios";
import { AxiosClient } from "../axios/axios";
import router from "../router";
import { SaveToken, ClearToken, GetToken } from "@/helpers/encrypt";
export const useAuthStore = defineStore("authStore", {
  state: () => ({
    user: null,
    name: null,
    email: null,
    prvi: ["y24834"],
    token: localStorage.getItem("token") || null,
    error: null,
    errors: {},
    isLoading: false,
    isSaving: false,
  }),

  getters: {
    isLoggedIn: () => GetToken() != null,
  },
  actions: {
    //Clear errors Action Start
    async clearErrors() {
      this.error = "";
      this.errors = {};
    },
    //clear errors end start
    //Login Action Start
    async login(formData) {
      this.isLoading = true;

      return new Promise((resolve, reject) => {
        AxiosClient.post(`/login`, formData, {
          withCredentials: true,
        })
          .then(async (res) => {
            if (res.status === 201) {
              await SaveToken(res.data.token);
              resolve(res);
            }
          })
          .catch((error) => {
            this.isLoading = false;
            if (error?.response?.data?.errors) {
              this.errors = error.response.data.errors;
            } else if (error?.response?.data?.message) {
              this.error = error?.response?.data?.message;
            } else {
              this.error = "Login failed. Please try again.";
            }
            reject(error);
          });
      });
    },

    // register action start
    async startRegister(formData) {
      this.isLoading = true;
      return new Promise((resolve, reject) => {
        AxiosClient.get(`/IuzLOW1`, formData)
          .then(async (res) => {
            resolve(res);
          })
          .catch((error) => {
            // this.isLoading = false;
            if (error?.response?.data?.errors) {
              this.errors = error.response.data.errors;
            } else if (error?.response?.data?.message) {
              this.error = error?.response?.data?.message;
            } else {
              this.error = "Login failed. Please try again.";
            }
            reject(error);
          });
      });
    },
    async registerAction(formData) {
      this.isSaving = true;

      return new Promise((resolve, reject) => {
        AxiosClient.post(`/IuzLOW1`, formData, {
          "content-type": "application/json",
        })
          .then(async (res) => {
            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    //Login Action End
    //Logout Action Start
    async logout() {
      // Clear the token and user data
      try {
        ClearToken();
        this.user = null;
        this.token = null;
        router.push({ name: "login" });
      } catch (error) {
        ClearToken();
        this.error = error?.response?.data?.message ?? "An error occurred";
        this.user = null;
        router.push({ name: "login" });
      }
    },
    //Logout Action End

    // Get User Action Start
    async getUser() {
      return new Promise((resolve, reject) => {
        AxiosClient.get(`usr`)
          .then((res) => {
            if (res.status === 201 || res.status === 200) {
              this.user = res?.data?.info;
              this.name = res?.data?.info?.name;
              this.email = res?.data?.info?.email;
              this.prvi = res?.data?.info?.abilities;
              resolve(res.data);
            }
          })
          .catch((error) => {
            if (error?.status === 401) {
              this.logout();
            }
            reject(error);
          });
      });
    },
    // Get User Action End

    // Get User Action Start
    async updatePassword(payload) {
      return new Promise((resolve, reject) => {
        AxiosClient.post(`usr`, payload)
          .then((res) => {
            if (res.status === 201 || res.status === 200) {
              resolve(res.data);
            }
          })
          .catch((error) => {
            if (error?.status === 401) {
              this.logout();
            }
            reject(error);
          });
      });
    },
    // Get User Action Start
    // async forgottenPassword(payload) {
    // this.isSaving = true
    //   return new Promise((resolve, reject) => {
    //     AxiosClient.post(`rftfG6n`, payload)
    //       .then((res) => {
    //         if (res.status === 201 || res.status === 200) {
    //           this.isSaving = false
    //           resolve(res);
    //         }
    //       })
    //       .catch((error) => {
    //           this.isSaving = false
    //         reject(error);
    //       });
    //   });
    // },
    // useAuthStore
    async forgottenPassword(email) {
      const body = {
        userEmail: email,
      };
      this.isSaving = true;
      this.error = null;
      try {
        const res = await AxiosClient.post("/rftfG6ni", body);
        return res;
      } catch (error) {
        this.error =
          error?.response?.data?.message || "Failed to send reset link";
        throw error;
      } finally {
        this.isSaving = false;
      }
    },
    // Get User Action Start
    async resetPassword(payload) {
      this.isSaving = true;
      return new Promise((resolve, reject) => {
        AxiosClient.post(`rftfG6n`, payload)
          .then((res) => {
            if (res.status === 201 || res.status === 200) {
              this.isSaving = false;
              resolve(res);
            }
          })
          .catch((error) => {
            this.isSaving = false;
            reject(error);
          });
      });
    },
    // Get User Action End

    // get privileges

    getPrivileges() {
      return new Promise((resolve, reject) => {
        AxiosClient.get(`v1/permissions`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // end of get privileges

    // request Token
    async requestToken(formData) {
      this.isLoading = true;
      return new Promise((resolve, reject) => {
        AxiosClient.post(`/dEcsAli`, formData)
          .then(async (res) => {
            this.isLoading = false;
            resolve(res);
          })
          .catch((error) => {
            this.isLoading = false;
            if (error?.response?.data?.errors) {
              this.errors = error.response.data.errors;
            } else if (error?.response?.data?.message) {
              this.error = error?.response?.data?.message;
            } else {
              this.error = "Login failed. Please try again.";
            }
            reject(error);
          });
      });
    },
    // request Token
    async loginWithToken(formData) {
      this.isLoading = true;
      return new Promise((resolve, reject) => {
        AxiosClient.post(`/dEcsAl`, formData)
          .then(async (res) => {
            this.isLoading = false;
            if (res.status === 201) {
              await SaveToken(res.data.token);
              this.isLoading = false;
              resolve(res);
            }
          })
          .catch((error) => {
            this.isLoading = false;
            if (error?.response?.data?.errors) {
              this.errors = error.response.data.errors;
            } else if (error?.response?.data?.message) {
              this.error = error?.response?.data?.message;
            } else {
              this.error = "Login failed. Please try again.";
            }
            reject(error);
          });
      });
    },
  },
});
